import { useEffect, useState } from "react"
import Accordion from "../campusLife/accordion"
import { useSelector } from "react-redux"
import { DecodeHtml } from "../../utils/decodeHtml"

const Others = () => {


    const state = useSelector(state => state.aboutUnitenContent)



    const aboutUniten = state?.data?.properties

    const title = aboutUniten?.title
    const description = DecodeHtml({ html: aboutUniten?.richTextContent?.markup })


    const [accordion, setAccordion] = useState([])

    useEffect(() => {
       
        setAccordion(
            aboutUniten?.accordionContent?.items?.map((content) => {
                let acc = content?.content?.properties
                return {
                    question: acc?.label,
                    answer: DecodeHtml({ html: acc?.accordionContent?.markup }),
                    open: false
                }
            }
            )
        )
    }, [aboutUniten?.accordionContent])


    


    return (
        <div className="flex flex-col gap-5 ">
            <h1 className="w-auto max-w-[30ch] text-3xl font-bold text-slate-900  2xl:text-5xl !leading-tight">{title}</h1>
            <p className='w-auto whitespace-pre-line'>{description}</p>
            

            <div className="my-5">
                {accordion && <Accordion accordion={accordion} setAccordion={setAccordion} />}
            </div>
        </div>
    )
}

export default Others